import React from "react";
import { useAuth } from "@/hooks/useAuth";
import { Navigate } from "react-router-dom";

const RotaProtegida = ({ children }) => {
  const { authUser, loading } = useAuth();

  if (loading) return null; // ou um spinner se quiser

  return authUser ? children : <Navigate to="/loginNovamente" replace />;
};

export default RotaProtegida;
